"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("@babel/runtime/helpers/inheritsLoose"),
  t = require("react");
function s(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var n = s(e),
  i = s(t);
function o(e) {
  return e && e.stopPropagation && e.stopPropagation(), e && e.preventDefault && e.preventDefault(), !1;
}
function r(e) {
  return null == e ? [] : Array.isArray(e) ? e.slice() : [e];
}
function a(e) {
  return null !== e && 1 === e.length ? e[0] : e.slice();
}
function p(e) {
  Object.keys(e).forEach(function (t) {
    "undefined" != typeof document && document.addEventListener(t, e[t], !1);
  });
}
function u(e, t) {
  return l(function (e, t) {
    var s = e;
    s <= t.min && (s = t.min);
    s >= t.max && (s = t.max);
    return s;
  }(e, t), t);
}
function l(e, t) {
  var s = (e - t.min) % t.step;
  var n = e - s;
  return 2 * Math.abs(s) >= t.step && (n += s > 0 ? t.step : -t.step), parseFloat(n.toFixed(5));
}
var h = function (e) {
  function t(t) {
    var s;
    (s = e.call(this, t) || this).onKeyUp = function () {
      s.onEnd();
    }, s.onMouseUp = function () {
      s.onEnd(s.getMouseEventMap());
    }, s.onTouchEnd = function () {
      s.onEnd(s.getTouchEventMap());
    }, s.onBlur = function () {
      s.setState({
        index: -1
      }, s.onEnd(s.getKeyDownEventMap()));
    }, s.onMouseMove = function (e) {
      s.setState({
        pending: !0
      });
      var t = s.getMousePosition(e),
        n = s.getDiffPosition(t[0]),
        i = s.getValueFromPosition(n);
      s.move(i);
    }, s.onTouchMove = function (e) {
      if (e.touches.length > 1) return;
      s.setState({
        pending: !0
      });
      var t = s.getTouchPosition(e);
      if (void 0 === s.isScrolling) {
        var _e = t[0] - s.startPosition[0],
          _n = t[1] - s.startPosition[1];
        s.isScrolling = Math.abs(_n) > Math.abs(_e);
      }
      if (s.isScrolling) return void s.setState({
        index: -1
      });
      var n = s.getDiffPosition(t[0]),
        i = s.getValueFromPosition(n);
      s.move(i);
    }, s.onKeyDown = function (e) {
      if (!(e.ctrlKey || e.shiftKey || e.altKey || e.metaKey)) switch (s.setState({
        pending: !0
      }), e.key) {
        case "ArrowLeft":
        case "ArrowDown":
        case "Left":
        case "Down":
          e.preventDefault(), s.moveDownByStep();
          break;
        case "ArrowRight":
        case "ArrowUp":
        case "Right":
        case "Up":
          e.preventDefault(), s.moveUpByStep();
          break;
        case "Home":
          e.preventDefault(), s.move(s.props.min);
          break;
        case "End":
          e.preventDefault(), s.move(s.props.max);
          break;
        case "PageDown":
          e.preventDefault(), s.moveDownByStep(s.props.pageFn(s.props.step));
          break;
        case "PageUp":
          e.preventDefault(), s.moveUpByStep(s.props.pageFn(s.props.step));
      }
    }, s.onSliderMouseDown = function (e) {
      if (!s.props.disabled && 2 !== e.button) {
        if (s.setState({
          pending: !0
        }), !s.props.snapDragDisabled) {
          var _t = s.getMousePosition(e);
          s.forceValueFromPosition(_t[0], function (e) {
            s.start(e, _t[0]), p(s.getMouseEventMap());
          });
        }
        o(e);
      }
    }, s.onSliderClick = function (e) {
      if (!s.props.disabled && s.props.onSliderClick && !s.hasMoved) {
        var _t2 = s.getMousePosition(e),
          _n2 = u(s.calcValue(s.calcOffsetFromPosition(_t2[0])), s.props);
        s.props.onSliderClick(_n2);
      }
    }, s.createOnKeyDown = function (e) {
      return function (t) {
        s.props.disabled || (s.start(e), p(s.getKeyDownEventMap()), o(t));
      };
    }, s.createOnMouseDown = function (e) {
      return function (t) {
        if (s.props.disabled || 2 === t.button) return;
        s.setState({
          pending: !0
        });
        var n = s.getMousePosition(t);
        s.start(e, n[0]), p(s.getMouseEventMap()), o(t);
      };
    }, s.createOnTouchStart = function (e) {
      return function (t) {
        if (s.props.disabled || t.touches.length > 1) return;
        s.setState({
          pending: !0
        });
        var n = s.getTouchPosition(t);
        s.startPosition = n, s.isScrolling = void 0, s.start(e, n[0]), p(s.getTouchEventMap()), function (e) {
          e.stopPropagation && e.stopPropagation();
        }(t);
      };
    }, s.handleResize = function () {
      var e = window.setTimeout(function () {
        s.pendingResizeTimeouts.shift(), s.resize();
      }, 0);
      s.pendingResizeTimeouts.push(e);
    }, s.renderThumb = function (e, t) {
      var n = s.props.thumbClassName + " " + s.props.thumbClassName + "-" + t + " " + (s.state.index === t ? s.props.thumbActiveClassName : ""),
        i = {
          ref: function ref(e) {
            s["thumb" + t] = e;
          },
          key: s.props.thumbClassName + "-" + t,
          className: n,
          style: e,
          onMouseDown: s.createOnMouseDown(t),
          onTouchStart: s.createOnTouchStart(t),
          onFocus: s.createOnKeyDown(t),
          tabIndex: 0,
          role: "slider",
          "aria-orientation": s.props.orientation,
          "aria-valuenow": s.state.value[t],
          "aria-valuemin": s.props.min,
          "aria-valuemax": s.props.max,
          "aria-label": Array.isArray(s.props.ariaLabel) ? s.props.ariaLabel[t] : s.props.ariaLabel,
          "aria-labelledby": Array.isArray(s.props.ariaLabelledby) ? s.props.ariaLabelledby[t] : s.props.ariaLabelledby
        },
        o = {
          index: t,
          value: a(s.state.value),
          valueNow: s.state.value[t]
        };
      return s.props.ariaValuetext && (i["aria-valuetext"] = "string" == typeof s.props.ariaValuetext ? s.props.ariaValuetext : s.props.ariaValuetext(o)), s.props.renderThumb(i, o);
    }, s.renderTrack = function (e, t, n) {
      var i = {
          key: s.props.trackClassName + "-" + e,
          className: s.props.trackClassName + " " + s.props.trackClassName + "-" + e,
          style: s.buildTrackStyle(t, s.state.upperBound - n)
        },
        o = {
          index: e,
          value: a(s.state.value)
        };
      return s.props.renderTrack(i, o);
    };
    var n = r(t.value);
    n.length || (n = r(t.defaultValue)), s.pendingResizeTimeouts = [];
    var l = [];
    for (var _e2 = 0; _e2 < n.length; _e2 += 1) {
      n[_e2] = u(n[_e2], t), l.push(_e2);
    }
    return s.resizeObserver = null, s.resizeElementRef = i.default.createRef(), s.state = {
      index: -1,
      upperBound: 0,
      sliderLength: 0,
      value: n,
      zIndices: l
    }, s;
  }
  n.default(t, e);
  var s = t.prototype;
  return s.componentDidMount = function () {
    "undefined" != typeof window && (this.resizeObserver = new ResizeObserver(this.handleResize), this.resizeObserver.observe(this.resizeElementRef.current), this.resize());
  }, t.getDerivedStateFromProps = function (e, t) {
    var s = r(e.value);
    return s.length ? t.pending ? null : {
      value: s.map(function (t) {
        return u(t, e);
      })
    } : null;
  }, s.componentDidUpdate = function () {
    0 === this.state.upperBound && this.resize();
  }, s.componentWillUnmount = function () {
    this.clearPendingResizeTimeouts(), this.resizeObserver && this.resizeObserver.disconnect();
  }, s.onEnd = function (e) {
    e && function (e) {
      Object.keys(e).forEach(function (t) {
        "undefined" != typeof document && document.removeEventListener(t, e[t], !1);
      });
    }(e), this.hasMoved && this.fireChangeEvent("onAfterChange"), this.setState({
      pending: !1
    }), this.hasMoved = !1;
  }, s.getValue = function () {
    return a(this.state.value);
  }, s.getClosestIndex = function (e) {
    var t = Number.MAX_VALUE,
      s = -1;
    var n = this.state.value,
      i = n.length;
    for (var _o = 0; _o < i; _o += 1) {
      var _i = this.calcOffset(n[_o]),
        _r = Math.abs(e - _i);
      _r < t && (t = _r, s = _o);
    }
    return s;
  }, s.getMousePosition = function (e) {
    return [e["page" + this.axisKey()], e["page" + this.orthogonalAxisKey()]];
  }, s.getTouchPosition = function (e) {
    var t = e.touches[0];
    return [t["page" + this.axisKey()], t["page" + this.orthogonalAxisKey()]];
  }, s.getKeyDownEventMap = function () {
    return {
      keydown: this.onKeyDown,
      keyup: this.onKeyUp,
      focusout: this.onBlur
    };
  }, s.getMouseEventMap = function () {
    return {
      mousemove: this.onMouseMove,
      mouseup: this.onMouseUp
    };
  }, s.getTouchEventMap = function () {
    return {
      touchmove: this.onTouchMove,
      touchend: this.onTouchEnd
    };
  }, s.getValueFromPosition = function (e) {
    var t = e / (this.state.sliderLength - this.state.thumbSize) * (this.props.max - this.props.min);
    return u(this.state.startValue + t, this.props);
  }, s.getDiffPosition = function (e) {
    var t = e - this.state.startPosition;
    return this.props.invert && (t *= -1), t;
  }, s.resize = function () {
    var e = this.slider,
      t = this.thumb0;
    if (!e || !t) return;
    var s = this.sizeKey(),
      n = e.getBoundingClientRect(),
      i = e[s],
      o = n[this.posMaxKey()],
      r = n[this.posMinKey()],
      a = t.getBoundingClientRect()[s.replace("client", "").toLowerCase()],
      p = i - a,
      u = Math.abs(o - r);
    this.state.upperBound === p && this.state.sliderLength === u && this.state.thumbSize === a || this.setState({
      upperBound: p,
      sliderLength: u,
      thumbSize: a
    });
  }, s.calcOffset = function (e) {
    var t = this.props.max - this.props.min;
    if (0 === t) return 0;
    return (e - this.props.min) / t * this.state.upperBound;
  }, s.calcValue = function (e) {
    return e / this.state.upperBound * (this.props.max - this.props.min) + this.props.min;
  }, s.calcOffsetFromPosition = function (e) {
    var t = this.slider,
      s = t.getBoundingClientRect(),
      n = s[this.posMaxKey()],
      i = s[this.posMinKey()];
    var o = e - (window["page" + this.axisKey() + "Offset"] + (this.props.invert ? n : i));
    return this.props.invert && (o = this.state.sliderLength - o), o -= this.state.thumbSize / 2, o;
  }, s.forceValueFromPosition = function (e, t) {
    var _this = this;
    var s = this.calcOffsetFromPosition(e),
      n = this.getClosestIndex(s),
      i = u(this.calcValue(s), this.props),
      o = this.state.value.slice();
    o[n] = i;
    for (var _e3 = 0; _e3 < o.length - 1; _e3 += 1) {
      if (o[_e3 + 1] - o[_e3] < this.props.minDistance) return;
    }
    this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0, this.setState({
      value: o
    }, function () {
      t(n), _this.fireChangeEvent("onChange");
    });
  }, s.clearPendingResizeTimeouts = function () {
    do {
      var _e4 = this.pendingResizeTimeouts.shift();
      clearTimeout(_e4);
    } while (this.pendingResizeTimeouts.length);
  }, s.start = function (e, t) {
    var s = this["thumb" + e];
    s && s.focus();
    var n = this.state.zIndices;
    n.splice(n.indexOf(e), 1), n.push(e), this.setState(function (s) {
      return {
        startValue: s.value[e],
        startPosition: void 0 !== t ? t : s.startPosition,
        index: e,
        zIndices: n
      };
    });
  }, s.moveUpByStep = function (e) {
    void 0 === e && (e = this.props.step);
    var t = u(this.state.value[this.state.index] + e, this.props);
    this.move(Math.min(t, this.props.max));
  }, s.moveDownByStep = function (e) {
    void 0 === e && (e = this.props.step);
    var t = u(this.state.value[this.state.index] - e, this.props);
    this.move(Math.max(t, this.props.min));
  }, s.move = function (e) {
    var _this$state = this.state,
      t = _this$state.index,
      s = _this$state.value,
      n = s.length,
      i = s[t];
    if (e === i) return;
    this.hasMoved || this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0;
    var _this$props = this.props,
      o = _this$props.pearling,
      r = _this$props.max,
      a = _this$props.min,
      p = _this$props.minDistance;
    if (!o) {
      if (t > 0) {
        var _n3 = s[t - 1];
        e < _n3 + p && (e = _n3 + p);
      }
      if (t < n - 1) {
        var _n4 = s[t + 1];
        e > _n4 - p && (e = _n4 - p);
      }
    }
    s[t] = e, o && n > 1 && (e > i ? (this.pushSucceeding(s, p, t), function (e, t, s, n) {
      for (var _i2 = 0; _i2 < e; _i2 += 1) {
        var _o2 = n - _i2 * s;
        t[e - 1 - _i2] > _o2 && (t[e - 1 - _i2] = _o2);
      }
    }(n, s, p, r)) : e < i && (this.pushPreceding(s, p, t), function (e, t, s, n) {
      for (var _i3 = 0; _i3 < e; _i3 += 1) {
        var _e5 = n + _i3 * s;
        t[_i3] < _e5 && (t[_i3] = _e5);
      }
    }(n, s, p, a))), this.setState({
      value: s
    }, this.fireChangeEvent.bind(this, "onChange"));
  }, s.pushSucceeding = function (e, t, s) {
    var n, i;
    for (n = s, i = e[n] + t; null !== e[n + 1] && i > e[n + 1]; n += 1, i = e[n] + t) {
      e[n + 1] = l(i, this.props);
    }
  }, s.pushPreceding = function (e, t, s) {
    for (var _n5 = s, _i4 = e[_n5] - t; null !== e[_n5 - 1] && _i4 < e[_n5 - 1]; _n5 -= 1, _i4 = e[_n5] - t) {
      e[_n5 - 1] = l(_i4, this.props);
    }
  }, s.axisKey = function () {
    return "vertical" === this.props.orientation ? "Y" : "X";
  }, s.orthogonalAxisKey = function () {
    return "vertical" === this.props.orientation ? "X" : "Y";
  }, s.posMinKey = function () {
    return "vertical" === this.props.orientation ? this.props.invert ? "bottom" : "top" : this.props.invert ? "right" : "left";
  }, s.posMaxKey = function () {
    return "vertical" === this.props.orientation ? this.props.invert ? "top" : "bottom" : this.props.invert ? "left" : "right";
  }, s.sizeKey = function () {
    return "vertical" === this.props.orientation ? "clientHeight" : "clientWidth";
  }, s.fireChangeEvent = function (e) {
    this.props[e] && this.props[e](a(this.state.value), this.state.index);
  }, s.buildThumbStyle = function (e, t) {
    var s = {
      position: "absolute",
      touchAction: "none",
      willChange: this.state.index >= 0 ? this.posMinKey() : void 0,
      zIndex: this.state.zIndices.indexOf(t) + 1
    };
    return s[this.posMinKey()] = e + "px", s;
  }, s.buildTrackStyle = function (e, t) {
    var s = {
      position: "absolute",
      willChange: this.state.index >= 0 ? this.posMinKey() + "," + this.posMaxKey() : void 0
    };
    return s[this.posMinKey()] = e, s[this.posMaxKey()] = t, s;
  }, s.buildMarkStyle = function (e) {
    var t;
    return (t = {
      position: "absolute"
    })[this.posMinKey()] = e, t;
  }, s.renderThumbs = function (e) {
    var t = e.length,
      s = [];
    for (var _n6 = 0; _n6 < t; _n6 += 1) {
      s[_n6] = this.buildThumbStyle(e[_n6], _n6);
    }
    var n = [];
    for (var _e6 = 0; _e6 < t; _e6 += 1) {
      n[_e6] = this.renderThumb(s[_e6], _e6);
    }
    return n;
  }, s.renderTracks = function (e) {
    var t = [],
      s = e.length - 1;
    t.push(this.renderTrack(0, 0, e[0]));
    for (var _n7 = 0; _n7 < s; _n7 += 1) {
      t.push(this.renderTrack(_n7 + 1, e[_n7], e[_n7 + 1]));
    }
    return t.push(this.renderTrack(s + 1, e[s], this.state.upperBound)), t;
  }, s.renderMarks = function () {
    var _this2 = this;
    var e = this.props.marks;
    var t = this.props.max - this.props.min + 1;
    return "boolean" == typeof e ? e = Array.from({
      length: t
    }).map(function (e, t) {
      return t;
    }) : "number" == typeof e && (e = Array.from({
      length: t
    }).map(function (e, t) {
      return t;
    }).filter(function (t) {
      return t % e == 0;
    })), e.map(parseFloat).sort(function (e, t) {
      return e - t;
    }).map(function (e) {
      var t = _this2.calcOffset(e),
        s = {
          key: e,
          className: _this2.props.markClassName,
          style: _this2.buildMarkStyle(t)
        };
      return _this2.props.renderMark(s);
    });
  }, s.render = function () {
    var _this3 = this;
    var e = [],
      t = this.state.value,
      s = t.length;
    for (var _n8 = 0; _n8 < s; _n8 += 1) {
      e[_n8] = this.calcOffset(t[_n8], _n8);
    }
    var n = this.props.withTracks ? this.renderTracks(e) : null,
      o = this.renderThumbs(e),
      r = this.props.marks ? this.renderMarks() : null;
    return i.default.createElement("div", {
      ref: function ref(e) {
        _this3.slider = e, _this3.resizeElementRef.current = e;
      },
      style: {
        position: "relative"
      },
      className: this.props.className + (this.props.disabled ? " disabled" : ""),
      onMouseDown: this.onSliderMouseDown,
      onClick: this.onSliderClick
    }, n, o, r);
  }, t;
}(i.default.Component);
h.displayName = "ReactSlider", h.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  pageFn: function pageFn(e) {
    return 10 * e;
  },
  minDistance: 0,
  defaultValue: 0,
  orientation: "horizontal",
  className: "slider",
  thumbClassName: "thumb",
  thumbActiveClassName: "active",
  trackClassName: "track",
  markClassName: "mark",
  withTracks: !0,
  pearling: !1,
  disabled: !1,
  snapDragDisabled: !1,
  invert: !1,
  marks: [],
  renderThumb: function renderThumb(e) {
    return i.default.createElement("div", e);
  },
  renderTrack: function renderTrack(e) {
    return i.default.createElement("div", e);
  },
  renderMark: function renderMark(e) {
    return i.default.createElement("span", e);
  }
};
var c = h;
exports.default = c;